import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PoliticPartiesService } from '../services/politic-parties.service';
import { QuestionsService } from '../services/questions.service';

@Injectable()
export class AppConfigService {
	public version: string;
	public apiEndpointSomeData: string;
	public clientCode: string;

	constructor(
		private http: HttpClient,
		private politicPartiesService: PoliticPartiesService,
		private questionsService: QuestionsService
	) {
		
	}

	load() :Promise<any>  {
		let element = this;
		let promise = new Promise(function(resolve, reject) 
		{
			element.http.get('/assets/config.parties.json')
			.subscribe(data => 
			{
				let response: any = data;
				element.politicPartiesService.setPoliticalParties(data);
				resolve(response);
			},
			error => 
			{
				reject(error);
			});
		}); 

		promise = new Promise(function(resolve, reject) 
		{
			element.http.get('/assets/config.questions.json')
			.subscribe(data => 
			{
				let response: any = data;
				element.questionsService.setQuestions(data);
				resolve(response);
			},
			error => 
			{
				reject(error);
			});
		}); 

		return promise;
	}
}